import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { AnnouncementActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function Announcement({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as AnnouncementActivity

  if (!activity.announcement?.summary) return null

  return <ItemWrapper notification={notification}>{activity.announcement.summary}</ItemWrapper>
}
